//Vercel Api
// export const Base_Url = "https://proposal-vercel-one.mkisan.com/api"
// export const Base_Url = "https://proposal-vercelapi.mkisan.com/api"
// export const Base_Url = "https://determined-easley.184-168-123-97.plesk.page/api"
// export const Base_Url = "https://nifty-herschel.184-168-123-97.plesk.page/api"

//Master Api
// export const Base_Url = "https://api.master.proposal.ust.outbooks.com/api"

// //temporyBAseURl;
// export const Base_Url = "https://angry-blackburn.101-53-133-129.plesk.page/api"

//Pre-Prod Api
export const Base_Url = "https://api.preprod.proposal.ust.outbooks.com/api";

//Production Api
// export const Base_Url = "https://api.app.proposal.ust.outbooks.com/api"

//Local redirect
// export const redirectUri = "http://localhost:3000";
//Client Vercel redirect
// export const redirectUri = "https://proposal-tool.vercel.app";
//New Vercel redirect
// export const redirectUri = "https://proposal-tool-one.vercel.app";
// export const redirectUri = "https://proposal-tool-dev.vercel.app";

//Master redirect
// export const redirectUri =  "https://master.proposal.outbooks.com";

//Pre-Prod redirect
export const redirectUri = "https://preprod.proposal.outbooks.com";

//Production redirect
// export const redirectUri = "https://app.proposal.outbooks.com";
// export const mergePdfApiUrl = "http://localhost:8080/mergeUserPdfs";
// export const generatePdfUrl = "http://localhost:8080/generatePdf";
// export const saveImage = "http://localhost:8080/save-image";
//new Dev Link

// export const mergePdfApiUrl = "https://multipurpose.mkisan.com/mergeUserPdfs";
// export const generatePdfUrl = "https://multipurpose.mkisan.com/generatePdf";
// export const saveImage = "https://multipurpose.mkisan.com/save-image";
export const mergePdfApiUrl =
  "https://proposal.pdfapi.wowinfosolutions.com/mergeUserPdfs";
export const generatePdfUrl =
  "https://proposal.pdfapi.wowinfosolutions.com/generatePdf";
export const saveImage =
  "https://proposal.pdfapi.wowinfosolutions.com/save-image";
//Production Link
// export const mergePdfApiUrl = "https://api.pdfgenration.proposal.ust.outbooks.com/mergeUserPdfs";
// export const generatePdfUrl = "https://api.pdfgenration.proposal.ust.outbooks.com/generatePdf";
// export const saveImage = "https://api.pdfgenration.proposal.ust.outbooks.com/save-image"
export const CompaniesHouseBase_Url = "https://api.companieshouse.gov.uk";

export const OldOutbooksBaseUrl = "https://proposal.outbooks.com/api";

export const AccessKeyBaseUrl =
  "https://api.api.preprod.proposal.ust.outbooks.com";
// export const AccessKeyBaseUrl = "https://api.api.app.proposal.ust.outbooks.com";
